import { cn } from '@/lib/utils';

/**
 * Shown where a pipeline stage hasn't produced anything yet. Replaces the old
 * greyed-out tab, which read as "broken" rather than "not reached yet" — the
 * explanation of *what unblocks it* is the point.
 */
export default function EmptyState({
  title,
  children,
  action,
  className,
}: {
  title?: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('rounded-lg border border-dashed border-border px-6 py-8 text-center', className)}>
      {title && <div className="mb-1.5 font-display text-sm font-semibold text-muted-foreground">{title}</div>}
      <p className="mx-auto m-0 max-w-md text-[13px] leading-relaxed text-faint">{children}</p>
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}
